<template>
  <div class="public-page">
    <div class="public-shell">
      <div class="public-head">
        <div>
          <div class="public-brand">{{ $t('app.name') }}</div>
          <h1 class="public-title">{{ $t('publicInvoice.title') }}</h1>
          <p class="public-subtitle">{{ $t('publicInvoice.subtitle') }}</p>
        </div>
        <div v-if="invoice" class="public-total">
          <span>{{ $t('publicInvoice.amountHead') }}</span>
          <strong>{{ formatUsd(invoice.amount) }}</strong>
        </div>
      </div>

      <el-card shadow="never" class="public-card" v-loading="loading">
        <template v-if="invoice">
          <div class="meta-row">
            <span class="meta-chip">{{ invoice.invoiceNo || $t('publicInvoice.invoiceNum', { id: invoice.id }) }}</span>
            <span class="meta-chip">{{ project ? (project.projectName || project.projectCode) : $t('publicInvoice.projectChip') }}</span>
          </div>

          <el-descriptions border :column="2">
            <el-descriptions-item :label="$t('publicInvoice.labelInvoiceNo')">{{ invoice.invoiceNo || '—' }}</el-descriptions-item>
            <el-descriptions-item :label="$t('publicInvoice.labelDate')">{{ invoice.invoiceDate || '—' }}</el-descriptions-item>
            <el-descriptions-item :label="$t('publicInvoice.labelProject')">{{ project ? (project.projectName || project.projectCode) : '—' }}</el-descriptions-item>
            <el-descriptions-item :label="$t('publicInvoice.amountHead')">{{ formatUsd(invoice.amount) }}</el-descriptions-item>
          </el-descriptions>

          <div class="section-actions">
            <el-button type="primary" plain :disabled="!downloadAvailable" @click="downloadInvoice">{{ $t('publicInvoice.download') }}</el-button>
          </div>
        </template>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { resolveApiBase } from '@/utils/apiBase'
import { formatUsd } from '@/utils/formatUsd'

const baseURL = resolveApiBase()

export default {
  name: 'PublicInvoice',
  data() {
    return {
      loading: false,
      invoice: null,
      project: null,
      downloadAvailable: false
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatUsd,
    async load() {
      this.loading = true
      try {
        const token = this.$route.params.token
        const res = await axios.get(`${baseURL}/api/public/invoice/${token}`)
        const payload = res.data && res.data.data ? res.data.data : res.data
        this.invoice = payload.invoice
        this.project = payload.project || null
        this.downloadAvailable = !!payload.downloadAvailable
      } catch (e) {
        this.$message.error('Unable to load invoice')
      } finally {
        this.loading = false
      }
    },
    downloadInvoice() {
      window.open(`${baseURL}/api/public/invoice/${this.$route.params.token}/download`, '_blank')
    }
  }
}
</script>

<style scoped>
.public-page {
  min-height: 100vh;
  padding: 32px 16px;
  background: radial-gradient(circle at top right, rgba(96, 165, 250, 0.08), transparent 25%), #0c0e14;
}

.public-shell {
  max-width: 900px;
  margin: 0 auto;
}

.public-head {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.public-brand {
  color: #60a5fa;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.public-title {
  margin: 8px 0 6px;
  color: #f8fafc;
  font-size: 28px;
}

.public-subtitle {
  margin: 0;
  color: #94a3b8;
}

.public-total {
  min-width: 180px;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.public-total span {
  display: block;
  color: #6b7785;
  margin-bottom: 8px;
}

.public-total strong {
  color: #f8fafc;
  font-size: 20px;
}

.public-card {
  border-radius: 18px;
}

.meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.meta-chip {
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: #cbd5e1;
  font-size: 12px;
}

.section-actions {
  margin-top: 18px;
}
</style>
